var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869507,
    y: 0.930664,
    width: 45.6788,
    height: 45.6788,
    rx: 15,
    fill: "#A67517",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 11C26.9882 11 28.6538 13.9148 28.2374 17.6624C27.821 21.41 26.1554 23.9084 29.4866 24.7412C31.9547 25.3583 36.9818 26.8233 36.9818 31.8201C36.9818 32.8812 36.149 35.9841 31.985 35.9841C26.9882 35.9841 26.1554 30.1545 20.7422 34.3185C19.8639 34.9941 17.9658 36.1477 16.1618 35.9841C14.0131 35.7892 11.9978 34.799 11.9978 31.4037C11.9978 26.9647 15.7454 27.2397 15.7454 23.492C15.7454 20.9936 11.9978 19.9087 11.9978 17.246C11.9978 14.7476 14.4962 15.164 17.8274 15.164C20.7422 15.164 21.9914 11 24.4898 11V11Z",
    fill: "#A67517"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6505 16.4307C35.3161 16.4307 36.9817 17.2635 36.9817 20.5947C36.9817 23.9259 33.0179 22.5432 31.9849 20.9937C30.3194 18.4953 31.985 16.4307 33.6505 16.4307Z",
    fill: "#A67517"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirty);
export default __webpack_public_path__ + "static/media/dirty.e6ce7ac5.svg";
export { ForwardRef as ReactComponent };